import { Base } from "ui/Scripts/source/framework/base";
import { ISharedPanel, SharedPanel } from "./sharedPanel";

export interface ISharedPanels {
    panels: ISharedPanel[];
}

export class SharedPanels implements ISharedPanels {
    panels: SharedPanel[];

    constructor();
    constructor(obj: ISharedPanels);
    constructor(obj?: any) {
        this.panels = Base.getTypedArray(obj ? obj.panels : null, SharedPanel);
    }
}